// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import AddCutLengthsButton from "@steiner/App/Components/AddCutLengthsButton/AddCutLengthsButton";
import { parseBoolean } from "@steiner/XDL/Utilities";
import * as React from "react";

type OwnProps = WidgetProps & HasProduct;

const ProductDetailsAddCutLengths: React.FC<OwnProps> = ({ product }) => {
    if (!parseBoolean(product?.properties?.allowCuts)) {
        return null;
    }

    return <AddCutLengthsButton data-test-selector="productDetails_addCutLengths" />;
};

const widgetModule: WidgetModule = {
    component: withProduct(ProductDetailsAddCutLengths),
    definition: {
        displayName: "Add Cut Lengths",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
